import { search } from '@/api/search'

const state = {
  search_words: '',
  searchResult: [],
  maxPage: 0,
  loading: false,
  noMore: true,
  isFirstLoad: false,
  firstCateIndex: null,
  secondCateIndex: null
}
const mutations = {
  SET_SEARCH_WORDS: (state, kw) => {
    state.search_words = kw || ''
  },
  SET_LOADING: (state, isLoading) => {
    state.loading = isLoading || false
  },
  SET_FIRST_INDEX: (state, firstCateIndex) => {
    state.firstCateIndex = firstCateIndex
  },
  SET_SECOND_INDEX: (state, secondCateIndex) => {
    state.secondCateIndex = secondCateIndex
  },
  SET_FIRST_LOAD: (state, isFirstLoad) => {
    state.isFirstLoad = isFirstLoad || false
  },
  SET_NO_MORE: (state, noMore) => {
    state.noMore = noMore || false
  },
  SET_SEARCH_RESULT: (state, result) => {
    state.searchResult = result || []
    if (state.searchResult.length !== 0) {
      state.maxPage = 1
    }
  },
  ADD_SEARCH_RESULT: (state, result) => {
    state.searchResult = state.searchResult.concat(result)
    state.maxPage = state.maxPage + 1
  },
  RESET_SEARCH_RESULT: (state, result) => {
    state.searchResult = []
    state.maxPage = 0
    state.noMore = false
  }
}

const actions = {
  // user login
  search ({ commit, state, dispatch }, searchData) {
    const {
      keyWords,
      isFirstLoad,
      firstCateIndex,
      secondCateIndex
      // , firstCategory, secondCategory, thirdCategory, fourthCategory

    } = searchData
    commit('SET_SEARCH_WORDS', keyWords)
    commit('SET_FIRST_INDEX', firstCateIndex)
    commit('SET_SECOND_INDEX', secondCateIndex)
    console.log('是否首次加载--》' + JSON.stringify(searchData))
    if (isFirstLoad) {
      commit('RESET_SEARCH_RESULT')
      commit('SET_FIRST_LOAD', isFirstLoad)
    }

    const searchParams = {
      keyWords: searchData.keyWords || '',
      sortBy: searchData.sortBy || 1,
      page: searchData.page || 1,
      pageSize: searchData.pageSize || 10
    }

    console.log(searchParams)

    return new Promise((resolve, reject) => {
      commit('SET_LOADING', true)
      search(searchParams).then(response => {
        const { data } = response
        if (data && data.length > 0) {
          commit('SET_NO_MORE', false)
          // console.log('没有走了no_more' + isFirstLoad)
          if (isFirstLoad) {
            commit('SET_SEARCH_RESULT', data)
          } else {
            commit('ADD_SEARCH_RESULT', data)
          }
        } else {
          // console.log('走了no_more' + isFirstLoad)
          commit('SET_NO_MORE', true)
        }
        commit('SET_LOADING', false)

        resolve()
        // commit('SET_FIRST_LOAD', false)
      }).catch(error => {
        console.log(error)
        commit('SET_LOADING', false)
        commit('SET_NO_MORE', true)
        reject(error)
        // commit('SET_FIRST_LOAD', false)
      })
    })
  },
  updateSearchWords ({ commit, state, dispatch }, searchData) {
    const {
      keyWords
    } = searchData
    commit('SET_SEARCH_WORDS', keyWords)
  },
  updateLoading ({ commit, state, dispatch }, searchData) {
    const {
      isLoading
    } = searchData
    commit('SET_LOADING', isLoading)
  },
  updateFirstLoad ({ commit, state, dispatch }, searchData) {
    const {
      isFirstLoad
    } = searchData
    commit('SET_FIRST_LOAD', isFirstLoad)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
